import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FloatLabel } from 'primeng/floatlabel';
import { InputText } from 'primeng/inputtext';
import { Select, SelectChangeEvent } from 'primeng/select';
import { TrimInputValueDirective } from '../../../../services/form/trim-input-value.directive';
import { AbschlussTyp } from '../abschluss-typ';
import { StudiumFormGroup } from '../../bewerbung-einreichen/bewerbung-einreichen-form-groups';
import { DateRangeComponent } from '../../../common/date-range/date-range.component';
import { Fieldset } from 'primeng/fieldset';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-studium[studiumFormGroup]',
  imports: [FloatLabel, InputText, ReactiveFormsModule, Select, TrimInputValueDirective, DateRangeComponent, Fieldset, Button],
  templateUrl: './studium.component.html',
  styleUrl: './studium.component.scss'
})
export class StudiumComponent {
  @Input()
  public studiumFormGroup!: FormGroup<StudiumFormGroup> | null;

  @Output()
  public remove: EventEmitter<void> = new EventEmitter<void>();

  protected diploma: { value: string; typ: AbschlussTyp }[] = [
    { value: 'Master of Business Administration', typ: AbschlussTyp.MASTER },
    { value: 'Master of Engineering', typ: AbschlussTyp.MASTER },
    { value: 'Master of Laws', typ: AbschlussTyp.MASTER },
    { value: 'Master of Science', typ: AbschlussTyp.MASTER },
    { value: 'Master of Arts', typ: AbschlussTyp.MASTER },
    { value: 'Bachelor of Engineering', typ: AbschlussTyp.BACHELOR },
    { value: 'Bachelor of Education', typ: AbschlussTyp.BACHELOR },
    { value: 'Bachelor of Laws', typ: AbschlussTyp.BACHELOR },
    { value: 'Bachelor of Science', typ: AbschlussTyp.BACHELOR },
    {
      value: 'Bachelor of Business Administration',
      typ: AbschlussTyp.BACHELOR
    },
    { value: 'Bachelor of Arts', typ: AbschlussTyp.BACHELOR },
    { value: 'abgebrochen', typ: AbschlussTyp.KEINER }
  ];

  protected diplomaChange($event: SelectChangeEvent): void {
    const selected: { value: string; typ: AbschlussTyp } | undefined = this.diploma.find(
      (e: { value: string; typ: AbschlussTyp }): boolean => e.value === $event.value
    );

    if (selected === undefined) {
      return;
    }

    this.studiumFormGroup!.controls.abschlussTyp.setValue(selected.typ);
  }
}
